import script from "./GoogleOAuthButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleOAuthButton.vue?vue&type=script&setup=true&lang=js"

import "./GoogleOAuthButton.vue?vue&type=style&index=0&id=b3282f0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3282f0a"]])

export default __exports__